import { render, staticRenderFns } from "./PaymentsMethods.vue?vue&type=template&id=3f05d05c&scoped=true"
import script from "./PaymentsMethods.vue?vue&type=script&lang=js"
export * from "./PaymentsMethods.vue?vue&type=script&lang=js"
import style0 from "./PaymentsMethods.vue?vue&type=style&index=0&id=3f05d05c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05d05c",
  null
  
)

export default component.exports